var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHtml(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_8566)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13889 0H17.1907C17.567 0 17.928 0.14916 18.1946 0.414804L23.4267 5.62865C23.6945 5.89551 23.845 6.25801 23.845 6.63608V21.4456C23.845 22.8546 22.6989 24 21.2914 24H8.13889C6.73071 24 5.58452 22.8546 5.58452 21.4456V10.3274H1.18263C0.613768 10.3274 0.15332 9.86688 0.15332 9.29811V4.05672C0.15332 3.48796 0.613768 3.02746 1.18263 3.02746H5.58452V2.55437C5.58452 1.14694 6.73071 0 8.13889 0ZM8.13889 22.4357H21.2914C21.8366 22.4357 22.2799 21.9916 22.2799 21.4456L22.2431 6.66525L18.9645 6.67466C17.9862 6.67466 17.1931 5.88074 17.1931 4.90325V1.55646L8.13889 1.56587C7.59366 1.56587 7.14969 2.00989 7.14969 2.55437V3.02746H15.611C16.1798 3.02746 16.6403 3.48796 16.6403 4.05672V9.29811C16.6403 9.86688 16.1798 10.3274 15.611 10.3274H7.14969V21.4456C7.14969 21.9916 7.59366 22.4357 8.13889 22.4357ZM2.75391 5.91797L2.05664 4.5H0.881836L2.07422 6.61523L0.849609 8.76562H2.03613L2.75391 7.32129L3.47168 8.76562H4.65527L3.43359 6.61523L4.62305 4.5H3.45117L2.75391 5.91797ZM7.06055 4.5H6.03223H4.77832V5.29395H6.03223V8.76562H7.06055V5.29395H8.34375V4.5H7.06055ZM9.50489 4.5H9.14747H8.63771V8.76562H9.66603V7.76953L9.57033 5.82769L10.506 8.76562H11.1857L12.1359 5.81204L12.0394 7.76953V8.76562H13.0707V4.5H12.558H12.2005H11.7201L10.8459 7.46777L9.98536 4.5H9.50489ZM14.097 8.76562H13.4349V4.5H14.4632V7.97461H15.8379V8.76562H14.4632H14.097Z",
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20L19.5 16.5L16.5 13",
    stroke: "#FF6B00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13L9.5 16.5L12.5 20",
    stroke: "#FF6B00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_8566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default SvgHtml;